<template>
  <div>
    <div class="row" v-if="smartMeter == 1">
      <div class="col-12">
        <label class="font-w400">{{ translate[lang]["metertitle"] }}</label>
        <div class="form-group">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              value="1"
              class="custom-control-input"
              id="meterStatus1"
              name="products[electricity][meter]"
              v-model="cMeter"
              :disabled="ratesloader"
            />
            <label class="custom-control-label" for="meterStatus1">{{
              translate[lang]["singlemeter"] +
              " (" +
              translate[lang]["mostchosen"] +
              ")"
            }}</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              value="2"
              class="custom-control-input"
              id="meterStatus2"
              name="products[electricity][meter]"
              v-model="cMeter"
              :disabled="ratesloader"
            />
            <label class="custom-control-label" for="meterStatus2">{{
              translate[lang]["doublemeter"]
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "Meter",
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState({
      meter: (state) => state.forms.meter,
      smartMeter: (state) => state.forms.smartMeter,
      ratesloader: (state) => state.forms.ratesloader,
    }),
    cMeter: {
      get() {
        return this.meter;
      },
      set(val) {
        this.setMeter(val);
        //this.setRates(this.enums.gas.value);
        this.setRates(this.enums.electricity.value);
      },
    },
  },
  methods: {
    ...mapMutations({
      setMeter: "forms/SET_METER",
      setSmartMeter: "forms/SET_SMART_METER",
    }),
  },
};
</script>

<style scoped></style>
